import * as _ from 'lodash';
import { FormEvent, Fragment, useEffect, useState } from 'react'
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap'
import { BANFFClassificationLabels } from './banff-classification-labels';
import { IBANFFClassification } from '@nkr/models/index';

interface IBANFF {
    tubulitis: number | null,
    intimalArteritis: number | null,
    c4d: number | null,
    interstitialFibrosis: number | null,
    tubularAtrophy: number | null,
    vascularFibrousIntimalThickening: number | null,
    mesangialMatrixExpansion: number | null,
    arterioloarHyalinosis: number | null,
    hyalineArterioloarThickening: number | null,
    totalInflammation: number | null,
    inflammationInAreaOfIfta: number | null,
    interstitialInflammation: number | null,
    glomerulitis: number | null,
    peritubularCapillaritis: number | null,
    gbmDoubleContours: number | null,
    tifta: number | null,
    pvl: number | null,
}

const BANFF_KEYS = Object.keys({
    tubulitis: -1,
    intimalArteritis: -1,
    c4d: -1,
    interstitialFibrosis: -1,
    tubularAtrophy: -1,
    vascularFibrousIntimalThickening: -1,
    mesangialMatrixExpansion: -1,
    arterioloarHyalinosis: -1,
    hyalineArterioloarThickening: -1,
    totalInflammation: -1,
    inflammationInAreaOfIfta: -1,
    interstitialInflammation: -1,
    glomerulitis: -1,
    peritubularCapillaritis: -1,
    gbmDoubleContours: -1,
    tifta: -1,
    pvl: -1,
}) as (keyof IBANFF)[];

interface IProps {
    data: IBANFFClassification,
    disabled: boolean,
    onSetBANFFClassification: (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => void
}

const BANFFClassification = (props: IProps) => {
    const [BANFFClassification, setBANFFClassification] = useState<IBANFF>({
        tubulitis: -1,
        intimalArteritis: -1,
        c4d: -1,
        interstitialFibrosis: -1,
        tubularAtrophy: -1,
        vascularFibrousIntimalThickening: -1,
        mesangialMatrixExpansion: -1,
        arterioloarHyalinosis: -1,
        hyalineArterioloarThickening: -1,
        totalInflammation: -1,
        inflammationInAreaOfIfta: -1,
        interstitialInflammation: -1,
        glomerulitis: -1,
        peritubularCapillaritis: -1,
        gbmDoubleContours: -1,
        tifta: -1,
        pvl: -1,
    })

    useEffect(() => {
        if (props.data != null) {
            let { tubulitis, intimalArteritis, c4d, interstitialFibrosis,
                tubularAtrophy, vascularFibrousIntimalThickening, mesangialMatrixExpansion, arterioloarHyalinosis,
                hyalineArterioloarThickening, totalInflammation, inflammationInAreaOfIfta, interstitialInflammation, glomerulitis,
                peritubularCapillaritis, gbmDoubleContours, tifta, pvl } = props.data;

            setBANFFClassification(prevState => ({
                ...prevState,
                tubulitis,
                intimalArteritis, c4d,
                interstitialFibrosis,
                tubularAtrophy,
                vascularFibrousIntimalThickening,
                mesangialMatrixExpansion,
                arterioloarHyalinosis,
                hyalineArterioloarThickening,
                totalInflammation,
                inflammationInAreaOfIfta,
                interstitialInflammation,
                glomerulitis,
                peritubularCapillaritis,
                gbmDoubleContours,
                tifta,
                pvl
            }));
        }
    }, [props.data])

    const handleBANFFClassification = (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => {
        const name = e.currentTarget.name;
        const value = parseInt(e.currentTarget.value);

        setBANFFClassification(prevState => ({ ...prevState, [name]: value }));
        props.onSetBANFFClassification(e);
    };

    if (props == null) {
        return <></>
    }

    return (
        <Row>
            {BANFF_KEYS.map((key) => (
                <Fragment key={key}>
                    <Col xs={12} sm={12} lg={4} componentClass={ControlLabel} style={{ marginBottom: 5 }}>
                        {BANFFClassificationLabels[key]}:
                    </Col>
                    <Col xs={12} sm={12} lg={2}>
                        <FormControl
                            componentClass='select'
                            name={key}
                            style={{ width: 'initial' }}
                            bsSize='sm'
                            disabled={props.disabled}
                            value={BANFFClassification[key]}
                            onChange={handleBANFFClassification}
                        >
                            <option key={`${key}` + '-unk'} value={-1}>{'Unknown'}</option>
                            <option key={`${key}` + '-0'} value={0}>{'0'}</option>
                            <option key={`${key}` + '-1'} value={1}>{'1'}</option>
                            <option key={`${key}` + '-2'} value={2}>{'2'}</option>
                            <option key={`${key}` + '-3'} value={3}>{'3'}</option>
                        </FormControl>
                    </Col>
                </Fragment>
            ))}
        </Row>
    )
}

export default BANFFClassification;